// extracted by mini-css-extract-plugin
export var invitation = "invitation-module--invitation--97682";
export var invitation__btn = "invitation-module--invitation__btn--30430";
export var video = "invitation-module--video--62f89";
export var videoBlock = "invitation-module--video-block--b7443";